import { render, staticRenderFns } from "./PurchaseOrdersTableExpansion.vue?vue&type=template&id=728ef16c&scoped=true&"
import script from "./PurchaseOrdersTableExpansion.vue?vue&type=script&lang=js&"
export * from "./PurchaseOrdersTableExpansion.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseOrdersTableExpansion.vue?vue&type=style&index=0&id=728ef16c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728ef16c",
  null
  
)

export default component.exports